import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import { TableChart } from '@material-ui/icons';
import * as React from 'react';
import { useAgent } from '../../hooks/use-agent';

import { usePageDialog } from '../../hooks/use-page-dialog';
import { AgentResultsErrorBoundary } from './agent-results-error-boundary';
import { AgentResultsTable } from './agent-results-table';
import { TableData } from './agent-types';

interface TableFeedPreviewProps {
    table: TableData;
}

export const TableFeedPreview: React.FC<TableFeedPreviewProps> = ({ table }) => {
    const { showDialog } = usePageDialog();
    const { conversationId } = useAgent();

    const handleClick = () => {
        showDialog(
            <AgentResultsErrorBoundary>
                <AgentResultsTable table={table} />
            </AgentResultsErrorBoundary>,
            `/orbit/chat/${conversationId}`,
            'replace'
        );
    };

    const rowCount = table.rows?.length ?? 0;
    const columnCount = table.columns?.length ?? 0;
    const rowCountText = `${rowCount} row${rowCount !== 1 ? 's' : ''}`;
    const columnCountText = `${columnCount} column${columnCount !== 1 ? 's' : ''}`;

    return (
        <Card variant="outlined" style={{ marginTop: 8, marginBottom: 8 }}>
            <CardActionArea onClick={handleClick}>
                <CardContent style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <TableChart style={{ fontSize: 32, color: '#1976d2' }} />
                    <div style={{ flex: 1 }}>
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                            {table.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {rowCountText} • {columnCountText}
                        </Typography>
                    </div>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
